// extracted by mini-css-extract-plugin
export default {"beat":"Interval_beat__SxHbr","LeadTitle":"Interval_LeadTitle__djgl4","LeadTitleDelete":"Interval_LeadTitleDelete__24M7m"};